import debug from 'debug';
import BaseSubClass from 'Global/Shared/Components/BaseComponent/BaseSubClass';
import ComponentStorage from 'Global/Shared/Components/ComponentStorage/ComponentStorage';
import Authentication from 'Minetilbud/Shared/Components/Authentication/Authentication';

import azIcon from 'Minetilbud/Shared/Icons/icon_filter_az.svg';
import basketSvg from 'Minetilbud/Shared/Icons/fk_basket_circle.svg';
import favoriteIcon from 'Minetilbud/Shared/Icons/icon_filter_favorite.svg';
import newestIcon from 'Minetilbud/Shared/Icons/icon_filter_newest.svg';

import Behaviour from '../static/behaviour';
import DataLayer from '../utils/data-layer';
import Templates from '../templates/sorting-type-templates';

const log = debug('FrontPageCatalogs:Render:SortingType');
const authentication = new Authentication();
const templates = new Templates();

class SortingType extends BaseSubClass {

	/**
	 * @param {element} element The element where sorting markup is inside
	 */
	constructor(element) {
		super(element);

		this.sortingEvent = this.sortingHandler.bind(this);
		this.componentStorage = new ComponentStorage({ componentKey: 'CustomerCatalogs' });

		this.initialize();
	}

	eventListeners() {
		this.dom.container.addEventListener('click', this.sortingEvent, false);
	}

	getSortingOptions() {
		const sortingType = this.componentStorage.getItem('sortingType');

		const sortingOptions = [
			{
				customCssClass: 'o-front-page-catalogs-sorting-type__option--online-shop',
				icon: basketSvg,
				label: templates.dictionaryText('sortingOnlineShop'),
				selected: sortingType === '-isOnline' ? true : false,
				type: '-isOnline'
			},
			{
				icon: azIcon,
				label: templates.dictionaryText('sortingAlphabetical'),
				selected: sortingType === null || !authentication.Authenticated() && sortingType === '-isFavorite' ? true : sortingType === 'name' ? true : false,
				type: 'name'
			},
			{
				icon: newestIcon,
				label: templates.dictionaryText('sortingNewest'),
				selected: sortingType === '-date' ? true : false,
				type: '-date'
			},
			{
				disabled: !authentication.Authenticated(),
				icon: favoriteIcon,
				label: templates.dictionaryText('sortingFavourites'),
				selected: !authentication.Authenticated() ? false : sortingType === '-isFavorite' ? true : false,
				type: '-isFavorite'
			}
		];

		return sortingOptions;
	}

	async initialize() {
		await templates.dictionaryInit();

		this.setup();
		this.setClassName('catalogs-sorting');
		this.initDomCache();

		this.render();
		this.eventListeners();
	}

	render() {
		const sortingOptions = this.getSortingOptions();

		sortingOptions.forEach(option => {
			this.dom.container.insertAdjacentHTML('beforeend', templates.sortingOption(option));
		});
	}

	setup() {
		this.element.insertAdjacentHTML('afterbegin', templates.base());
	}

	/**
	 * @param {Event} event 
	 */
	sortingHandler(event) {
		event.preventDefault();
		
		const sortingTypeElement = event.target.closest('[data-js="catalogs-sorting-type"]');
		if (sortingTypeElement === null || sortingTypeElement.classList.contains('is-disabled')) return;

		this.dom.container.querySelector('.is-selected').classList.remove('is-selected');
		sortingTypeElement.classList.add('is-selected');

		const sortingName = sortingTypeElement.innerText.trim();
		const sortingType = sortingTypeElement.getAttribute('data-type');

		DataLayer.filterAdd({ filterName: sortingName, filterType: 'sorting' });

		this.componentStorage.setItem('sortingType', sortingType);
		Behaviour.dispatchEvent(Behaviour.eventKeys.sortingType, { sortingType });
	}

}

export default SortingType;
